import * as React from "react";
const SvgGmailIcon = props => <svg viewBox="0 0 125.694 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g id="Gmail_icon_(2026) 1" clipPath="url(#clip0_6465_16273)"><path id="path1" d="M98.5558 12.8574H125.694V91.4286C125.694 96.1622 121.857 100 117.124 100H102.841C102.278 100 101.721 99.8892 101.201 99.6738C100.681 99.4584 100.209 99.1428 99.8108 98.7448C99.4129 98.3468 99.0973 97.8744 98.882 97.3544C98.6666 96.8344 98.5558 96.2772 98.5558 95.7143V12.8574Z" fill="url(#paint0_linear_6465_16273)" /><path id="path2" d="M27.1387 12.8574H0.000236351V91.4286C0.000236351 96.1622 3.83748 100 8.57029 100H22.8537C23.4164 100 23.9736 99.8892 24.4935 99.6738C25.0134 99.4584 25.4858 99.1428 25.8837 98.7448C26.2816 98.3468 26.5972 97.8744 26.8126 97.3544C27.0279 96.8344 27.1387 96.2772 27.1387 95.7143V12.8574Z" fill="var(--fill-0, #FC413D)" style={{
      fill: "color(display-p3 0.9882 0.2549 0.2392)",
      fillOpacity: 1
    }} /><path id="path3" d="M22.3013 3.18305C16.5643 -1.6398 8.005 -0.898372 3.18291 4.83947C-1.63917 10.5766 -0.897858 19.1373 4.83908 23.9609L59.1718 69.6386C60.2013 70.5041 61.5031 70.9786 62.848 70.9786C64.1929 70.9786 65.4947 70.5041 66.5242 69.6386L120.857 23.9602C126.593 19.1373 127.334 10.5766 122.512 4.83876C117.69 -0.898373 109.131 -1.6398 103.395 3.18305L62.8476 37.2716L22.3013 3.18305Z" fill="url(#paint1_linear_6465_16273)" /></g><defs><linearGradient id="paint0_linear_6465_16273" x1={112.125} y1={12.8574} x2={112.125} y2={100} gradientUnits="userSpaceOnUse"><stop stopColor="#60D673" style={{
        stopColor: "color(display-p3 0.3765 0.8392 0.4510)",
        stopOpacity: 1
      }} /><stop offset={0.17} stopColor="#42C868" style={{
        stopColor: "color(display-p3 0.2588 0.7843 0.4078)",
        stopOpacity: 1
      }} /><stop offset={0.39} stopColor="#0EBC5F" style={{
        stopColor: "color(display-p3 0.0549 0.7373 0.3725)",
        stopOpacity: 1
      }} /><stop offset={0.62} stopColor="#00A9BB" style={{
        stopColor: "color(display-p3 0.0000 0.6627 0.7333)",
        stopOpacity: 1
      }} /><stop offset={0.86} stopColor="#3C90FF" style={{
        stopColor: "color(display-p3 0.2353 0.5647 1.0000)",
        stopOpacity: 1
      }} /><stop offset={1} stopColor="#3186FF" style={{
        stopColor: "color(display-p3 0.1922 0.5255 1.0000)",
        stopOpacity: 1
      }} /></linearGradient><linearGradient id="paint1_linear_6465_16273" x1={0.000568654} y1={14.3787} x2={125.695} y2={14.3787} gradientUnits="userSpaceOnUse"><stop offset={0.08} stopColor="#FF63A0" style={{
        stopColor: "color(display-p3 1.0000 0.3882 0.6275)",
        stopOpacity: 1
      }} /><stop offset={0.3} stopColor="#FC413D" style={{
        stopColor: "color(display-p3 0.9882 0.2549 0.2392)",
        stopOpacity: 1
      }} /><stop offset={0.5} stopColor="#FC413D" style={{
        stopColor: "color(display-p3 0.9882 0.2549 0.2392)",
        stopOpacity: 1
      }} /><stop offset={0.65} stopColor="#FC413D" style={{
        stopColor: "color(display-p3 0.9882 0.2549 0.2392)",
        stopOpacity: 1
      }} /><stop offset={0.72} stopColor="#FC5C30" style={{
        stopColor: "color(display-p3 0.9882 0.3608 0.1882)",
        stopOpacity: 1
      }} /><stop offset={0.86} stopColor="#FEB10C" style={{
        stopColor: "color(display-p3 0.9961 0.6941 0.0471)",
        stopOpacity: 1
      }} /><stop offset={0.91} stopColor="#FEC700" style={{
        stopColor: "color(display-p3 0.9961 0.7804 0.0000)",
        stopOpacity: 1
      }} /><stop offset={0.96} stopColor="#FFDB0F" style={{
        stopColor: "color(display-p3 1.0000 0.8588 0.0588)",
        stopOpacity: 1
      }} /></linearGradient><clipPath id="clip0_6465_16273"><rect width={125.694} height={100} fill="white" style={{
        fill: "white",
        fillOpacity: 1
      }} /></clipPath></defs></svg>;
export default SvgGmailIcon;